module.exports = __webpack_public_path__ + "img/10.35f31306.jpg";